import { json } from "../shared/fetcher";

const NOOP = () => {};
const SUBMIT_RECAPTCHA = "submitRecaptcha";

function executeRecaptcha({ success = NOOP, fail = NOOP, always = NOOP } = {}) {
  const { grecaptcha } = window;

  function submitRecaptcha() {
    const url = `/recaptcha?g-recaptcha-response=${grecaptcha.getResponse()}`;

    return json(url)
      .then(() => {
        success();
        window[SUBMIT_RECAPTCHA] = null;
      })
      .catch(fail)
      .finally(always);
  }

  if (grecaptcha && grecaptcha.execute) {
    window[SUBMIT_RECAPTCHA] = submitRecaptcha;

    grecaptcha.execute();
  }
}

export default executeRecaptcha;



// WEBPACK FOOTER //
// ./utils/Recaptcha.js